import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtpInputComponent } from './otp-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputRegexModule } from '@app/_shared/directives';



@NgModule({
  declarations: [OtpInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputRegexModule
  ],
  exports:[
    OtpInputComponent
  ]
})
export class OtpInputModule { }
